module.exports = __webpack_public_path__ + "img/pallologo.158f6a83.png";